import React, { ReactNode } from 'react';
import { IconTooltip } from './IconTooltip';

interface SectionCardProps {
    title: string;
    icon?: ReactNode;
    extra?: ReactNode;
    children: ReactNode;
    className?: string;
    bodyClassName?: string;
    headerClassName?: string;
}

export const SectionCard: React.FC<SectionCardProps> = ({
    title,
    icon,
    extra,
    children,
    className = '',
    bodyClassName = 'p-6',
    headerClassName = ''
}) => {
    return (
        <div className={`bg-card rounded-2xl border shadow-sm overflow-hidden h-full ${className}`}>
            <div className={`px-6 py-4 border-b bg-secondary/5 flex items-center justify-between ${headerClassName}`}>
                <div className="flex items-center gap-3">
                    <IconTooltip content={title}>
                        <div className="flex items-center">
                            {React.isValidElement(icon) && React.cloneElement(icon as React.ReactElement<any>, {
                                className: 'w-5 h-5 text-primary'
                            })}
                        </div>
                    </IconTooltip>
                    <h3 className="font-bold text-foreground">{title}</h3>
                </div>
                {extra && (
                    <div className="flex items-center">
                        {extra}
                    </div>
                )}
            </div>
            <div className={bodyClassName}>
                {children}
            </div>
        </div>
    );
};
